// Rendered when an error reaches the top of the application unhandled. Keep it simple — an error thrown here falls through to Redwood's generic error page.

// This import will be automatically removed when building for production
import { DevFatalErrorPage } from '@redwoodjs/web/dist/components/DevFatalErrorPage';
import type { ComponentType } from 'react';

type FatalErrorPageProps = { error?: Error };

// Type the default export explicitly so it matches FatalErrorBoundary's
// `page: ComponentType<{ error?: Error }>` contract. DevFatalErrorPage uses
// a richer ErrorWithRequestMeta which is fine to widen in component-type
// position (React.ComponentType variance allows it).
const FatalErrorPage: ComponentType<FatalErrorPageProps> =
  // DevFatalErrorPage's prop type is narrower (ErrorWithRequestMeta) than the
  // boundary contract (Error). Its body uses optional chaining on the extra
  // fields, so the runtime is safe — widen via cast for TS.
  (DevFatalErrorPage as ComponentType<FatalErrorPageProps> | undefined) ||
  ((_props: FatalErrorPageProps) => (
    <main>
      <style
        dangerouslySetInnerHTML={{
          __html: `
              html, body {
                margin: 0;
              }
              html * {
                box-sizing: border-box;
              }
              main {
                display: flex;
                align-items: center;
                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
                text-align: center;
                background-color: #E2E8F0;
                height: 100vh;
              }
              section {
                background-color: white;
                border-radius: 0.25rem;
                width: 32rem;
                padding: 1rem;
                margin: 0 auto;
                box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
              }
              h1 {
                font-size: 2rem;
                margin: 0;
                font-weight: 500;
                line-height: 1;
                color: #2D3748;
              }
            `,
        }}
      />
      <section>
        <h1>
          <span>Something went wrong</span>
        </h1>
      </section>
    </main>
  ));

export default FatalErrorPage;
